import { Table, TableColumnType, TextHeader } from '@eltoro-ui/components'
import { usePagination } from '@eltoro-ui/hooks'
import { V1JobType, V1TargetJobSearch } from 'next-gen-sdk'
import { simplifyEnum, userFriendlyAudienceName } from 'Helpers'
import { ETIcon } from 'Assets'
import { EmptyField, TablePagination } from 'Components'
import { OrgNameCell } from 'Pages/SearchPage/OrgNameCell'

const getTargetIconName = (type: V1JobType) => {
  if (type === 'JOB_TYPE_MAID' || type === 'JOB_TYPE_DEVICE') return 'maid'
  if (type === 'JOB_TYPE_ESCROWMOVER' || type === 'JOB_TYPE_PREMOVER')
    return 'digital-new-movers'
  if (type === 'JOB_TYPE_POSTMOVER') return 'movers'
  if (type === 'JOB_TYPE_VR') return 'venue-replay'
  if (type === 'JOB_TYPE_B2B') return 'b2b'
  if (type === 'JOB_TYPE_B2C') return 'b2c'
  if (type === 'JOB_TYPE_DC') return 'digital-canvassing'
  if (type === 'JOB_TYPE_RETARGETING') return 'retargeting'
  if (type === 'JOB_TYPE_IP') return 'ip-targeting'
  if (type === 'JOB_TYPE_IPSFORGEOJSON' || type === 'JOB_TYPE_IPSFORWKB')
    return 'map-polygon'
  if (type === 'JOB_TYPE_DIRECTMAIL') return 'direct-mail'
  if (type === 'JOB_TYPE_ZIP') return 'locator'
  return 'target'
}

const searchJobTableColumns: TableColumnType<V1TargetJobSearch>[] = [
  {
    path: 'name',
    label: 'Name',
    removeFilter: true,
    RowCell: ({ name, type }) => {
      return (
        <>
          {type && (
            <ETIcon
              className="AudienceLibrary__icon-custom h-9 w-11"
              icon={getTargetIconName(type)}
            />
          )}
          {name ? (
            <div className="AudienceLibrary__icon-filename ml-2 flex max-w-full flex-1 items-center gap-1">
              <span className="TruncateFileName flex-1 truncate">{name}</span>
            </div>
          ) : (
            <div className="AudienceLibrary__icon-filename flex max-w-full flex-1 items-center gap-1">
              No name
            </div>
          )}
        </>
      )
    },
  },
  {
    path: 'type',
    label: 'Type',
    removeFilter: true,
    RowCell: ({ type }) =>
      type ? userFriendlyAudienceName(type) : <EmptyField />,
  },
  {
    path: 'tag',
    label: 'Tag',
    removeFilter: true,
    RowCell: ({ tag }) => (tag ? tag : <EmptyField />),
  },
  {
    path: 'status',
    label: 'Status',
    removeFilter: true,
    RowCell: ({ status }) =>
      status ? simplifyEnum(2, status) : <EmptyField />,
  },
  {
    path: 'orgId',
    label: 'Source Org',
    removeFilter: true,
    RowCell: ({ orgLogo, orgName }) =>
      orgName ? <OrgNameCell name={orgName} logo={orgLogo} /> : <EmptyField />,
  },
  {
    path: 'targetJobId',
    label: 'ID',
    removeFilter: true,
  },
]

export const SearchAudienceTable: React.FC<{
  handleRowClick: (clicked: V1TargetJobSearch) => void
  jobs?: V1TargetJobSearch[]
}> = ({ jobs, handleRowClick }) => {
  const targetPagination = usePagination<V1TargetJobSearch>({
    pageSize: 5,
    sourceData: jobs || [],
  })

  if (!jobs?.length) return null

  return (
    <div className="SearchAudienceTable">
      <TextHeader type={4} className="SearchAudienceTable__header mt-4">
        Audiences ({jobs?.length || 0})
      </TextHeader>
      <div className="p-4">
        <Table
          columns={searchJobTableColumns}
          rows={targetPagination.data}
          onClick={(audience) => handleRowClick(audience)}
        />
        <div className="flex justify-end pt-2">
          <TablePagination pagination={targetPagination} />
        </div>
      </div>
    </div>
  )
}
